// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { toTitleCase } from "../../../utils";
import { Task } from "../Task";
import { US_MO_SIGNIFICANT_OTHER_DEFINITION } from "./constants";

class UsMoInitialPositiveContactWithSignificantOtherIapTask extends Task<"usMoInitialPositiveContactWithSignificantOtherIap"> {
  get additionalDetails() {
    return "No initial positive contact with significant other recorded since starting IAP.";
  }

  get frequency() {
    return toTitleCase(this.details.contactCadence);
  }

  get tooltipCopy() {
    return US_MO_SIGNIFICANT_OTHER_DEFINITION;
  }
}

export default UsMoInitialPositiveContactWithSignificantOtherIapTask;
